"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationRoutes = void 0;
var ApplicationRoutes;
(function (ApplicationRoutes) {
    ApplicationRoutes["BasePrefix"] = "applications";
    ApplicationRoutes["ById"] = ":applicationId";
    ApplicationRoutes["All"] = "all";
    ApplicationRoutes["List"] = "list";
    ApplicationRoutes["SayHello"] = "say-hello";
    ApplicationRoutes["SendRequisite"] = "send-requisite";
    ApplicationRoutes["SendInvoiceRequirements"] = "send-invoice-requirements";
    ApplicationRoutes["SendContractTemplate"] = "send-contract-template";
    ApplicationRoutes["SendChatFile"] = "send-chat-file";
    ApplicationRoutes["SendChatFileLink"] = "send-chat-file-link";
    ApplicationRoutes["ToWork"] = "to-work";
    ApplicationRoutes["ToNew"] = "to-new";
    ApplicationRoutes["ToContractNegotiation"] = "to-contract-negotiation";
    ApplicationRoutes["ToContractSigning"] = "to-contract-signing";
    ApplicationRoutes["ToInvoiceNegotiation"] = "to-invoice-negotiation";
    ApplicationRoutes["ToAssignmentNegotiation"] = "to-assignment-negotiation";
    ApplicationRoutes["ToAssignmentSigning"] = "to-assignment-signing";
    ApplicationRoutes["ToAwaitingPayments"] = "to-awaiting-payments";
    ApplicationRoutes["ToAssignmentExecution"] = "to-assignment-execution";
    ApplicationRoutes["ToAwaitingConfirmation"] = "to-awaiting-confirmation";
    ApplicationRoutes["ToActSigning"] = "to-act-signing";
    ApplicationRoutes["ToActSigned"] = "to-act-signed";
    ApplicationRoutes["ParseDocument"] = "parse-document";
    ApplicationRoutes["SendAssignment"] = "send-assignment";
    ApplicationRoutes["GenerateExcel"] = "generate-excel";
    ApplicationRoutes["AllByClientId"] = "all-by-client/:clientId";
})(ApplicationRoutes = exports.ApplicationRoutes || (exports.ApplicationRoutes = {}));
